import { useState, useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import api from "../../../configs/api";
import HomePropertyCard from "../userCommon/HomePropertyCard";
import ComingSoonCard from "../userCommon/ComingSoonCard";
import HomePropertyCardSkeleton from "../userCommon/HomePropertyCardSkeleton";

const RecommendedPropertySection = () => {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProperties = async () => {
      try {
        setLoading(true);
        const res = await api.get("/properties/home?type=residential&count=5");
        const data = res.data?.data || [];
        setProperties(data.slice(0, 5));
      } catch (err) {
        console.error("Error fetching properties:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchProperties();
  }, []);

  return (
    <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10  bg-white py-6 md:py-8 lg:py-10">
      <div className="mx-auto">
        {/* Header */}
        <div className="flex justify-between items-center pb-6 md:pb-8 lg:pb-10">
          <h2 className="font-medium text-[#031722] text-lg sm:text-xl md:text-2xl ">
            Recommended Properties
          </h2>

          <button
            onClick={() => {
              navigate("/properties");
              window.scrollTo(0, 0);
            }}
            className="flex items-center gap-1 sm:gap-2 text-red-600 font-medium text-xs sm:text-base "
          >
            View all <ArrowRight className="w-3 sm:w-4 h-3 sm:h-4" />
          </button>
        </div>

        {/* SMART RESPONSIVE GRID */}
        <div className="flex gap-4 overflow-x-auto scrollbar-none snap-x snap-mandatory xl:grid xl:grid-cols-5 xl:overflow-x-visible xl:snap-none">
          {!loading &&
            properties?.map((property, i) => (
              <div
                key={property?._id || i}
                className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
              >
                <HomePropertyCard property={property} />
              </div>
            ))}

          {/* Skeleton loaders while loading */}
          {loading &&
            Array.from({ length: 5 }).map((_, i) => (
              <div
                key={"skeleton-" + i}
                className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
              >
                <HomePropertyCardSkeleton />
              </div>
            ))}

          {/* Coming Soon fillers if less than 5 after load */}
          {!loading &&
            properties.length < 5 &&
            Array.from({ length: 5 - properties.length }).map((_, i) => (
              <div
                key={"coming-" + i}
                className="snap-start shrink-0 w-[75%] sm:w-[50%] md:w-[33%] xl:w-auto xl:max-w-sm"
              >
                <ComingSoonCard />
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default RecommendedPropertySection;


// import { useState, useEffect } from "react";
// import { ArrowRight, CheckCircle, Heart, Clock } from "lucide-react";
// import homeImg from "../../../assets-user/home.png";
// import { useNavigate } from "react-router-dom";
// import api from "../../../configs/api";
// import { formatPrice } from "../../../utils/helpers";

// const RecommendedPropertySection = () => {
//   const [properties, setProperties] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   const truncateText = (text, limit) => {
//     if (!text) return "";
//     return text.length > limit ? text.slice(0, limit) + "..." : text;
//   };

//   // Fetch recommended properties from API
//   useEffect(() => {
//     const fetchProperties = async () => {
//       try {
//         setLoading(true);
//         const response = await api.get("/properties?type=residential");
//         const data = response.data?.data || [];
//         const limitedData = data.slice(0, 4);
//         setProperties(limitedData);
//       } catch (error) {
//         console.error("Error fetching properties:", error);
//         setProperties([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProperties();
//   }, []);

//   // Coming Soon
//   const getComingSoonCount = () => {
//     if (loading) return 0;
//     const propertyCount = properties.length;
//     if (propertyCount === 1) return 3;
//     if (propertyCount === 2) return 2;
//     if (propertyCount === 3) return 1;
//     return 0;
//   };

//   const comingSoonCount = getComingSoonCount();

//   // Render Coming Soon Card
//   const renderComingSoonCard = (index) => (
//     <div
//       key={`coming-soon-${index}`}
//       data-aos="zoom-in-up"
//       className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg overflow-hidden shadow-md flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start border-2 border-dashed border-gray-300 mb-4"
//     >
//       {/* Image Section with Coming Soon Message */}
//       <div className="relative h-48 sm:h-52 bg-gradient-to-br from-gray-200 to-gray-300 flex items-center justify-center">
//         <div className="text-center">
//           <Clock className="w-12 h-12 text-gray-400 mx-auto mb-3 animate-pulse" />
//           <p className="text-gray-600 font-semibold text-lg">Coming Soon</p>
//           <p className="text-gray-500 text-sm mt-1">New properties arriving</p>
//         </div>
//       </div>

//       {/* Property Details Placeholder */}
//       <div className="p-4">
//         <div className="space-y-2">
//           <div className="h-5 bg-gray-300 rounded w-3/4 animate-pulse"></div>
//           <div className="h-4 bg-gray-200 rounded w-full animate-pulse"></div>
//           <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse mt-3"></div>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="w-full px-4 sm:px-6 md:px-8 lg:px-10 py-6 md:py-8 lg:py-10 bg-white">
//       <div className="mx-auto ">
//         {/* Header Section */}
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="font-medium text-[#031722] tracking-[0.01em] leading-[150%] text-lg sm:text-xl md:text-2xl lg:text-3xl">
//             Recommended Property
//           </h2>

//           <button
//             onClick={() => {
//               navigate("/properties");
//               window.scrollTo(0, 0);
//             }}
//             className="flex items-center gap-2 text-red-600 font-medium text-sm sm:text-base"
//           >
//             View all
//             <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5" />
//           </button>
//         </div>

//         {/* Property Cards */}
//         <div className="flex overflow-x-auto lg:overflow-hidden gap-4 md:gap-6 lg:grid lg:grid-cols-4 scroll-smooth snap-x snap-mandatory ">
//           {/* Render actual property cards */}
//           {(loading ? Array(4).fill(0) : properties).map((property, index) => {
//             // Get thumbnail image
//             const thumbnail =
//               property?.images?.find((img) => img.isThumbnail)?.url ||
//               property?.images?.[0]?.url ||
//               homeImg;

//             return (
//               <div
//                 key={property._id || index}
//                 onClick={() => {
//                   // Navigate to property details by ID
//                   navigate(`/properties/residential/${property._id}`);
//                   window.scrollTo(0, 0);
//                 }}
//                 data-aos="zoom-in-up"
//                 className="bg-white rounded-lg overflow-hidden shadow-md flex-shrink-0 w-[80%] md:w-[70%] lg:w-auto snap-start cursor-pointer mb-4 border-2"
//               >
//                 {/* Image Section */}
//                 <div className="relative overflow-hidden bg-gray-100">
//                   {loading ? (
//                     <div className="h-48 sm:h-52 bg-gray-200 animate-pulse"></div>
//                   ) : (
//                     <>
//                       <img
//                         src={thumbnail}
//                         alt={property.title || "Property"}
//                         className="w-full h-48 sm:h-52 object-cover transition-transform duration-500 hover:scale-105"
//                       />
//                       {property.isApproved && (
//                         <div className="absolute top-3 left-3 bg-green-600 text-white px-2 py-1 rounded-md flex items-center gap-1 text-xs font-semibold">
//                           <CheckCircle className="w-3 h-3" />
//                           <span>Verified</span>
//                         </div>
//                       )}
//                       <div className="absolute bottom-3 right-3 bg-white px-2 py-1 rounded-md shadow-md">
//                         <span className="text-sm font-semibold text-gray-900">
//                           {formatPrice(
//                             property?.price ||
//                               property?.property?.price ||
//                               "Price on Request"
//                           )}
//                         </span>
//                       </div>
//                       <button className="absolute top-3 right-3 bg-white p-2 rounded-full shadow-md">
//                         <Heart className="w-4 h-4 text-gray-600" />
//                       </button>
//                     </>
//                   )}
//                 </div>

//                 {/* Property Details */}
//                 <div className="p-4 ">
//                   {loading ? (
//                     <div className="space-y-2">
//                       <div className="h-5 bg-gray-300 rounded w-3/4"></div>
//                       <div className="h-4 bg-gray-200 rounded w-full"></div>
//                     </div>
//                   ) : (
//                     <>
//                       <h3
//                         className="font-medium text-[#031722] text-base sm:text-lg md:text-xl mb-2"
//                         style={{
//                           display: "-webkit-box",
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                           WebkitLineClamp: 1,
//                         }}
//                       >
//                         {truncateText(property.title || "Untitled Property")}
//                       </h3>

//                       <p
//                         className="text-[#6A6A6A] text-sm sm:text-base mb-2"
//                         style={{
//                           display: "-webkit-box",
//                           WebkitBoxOrient: "vertical",
//                           overflow: "hidden",
//                           WebkitLineClamp: 2,
//                         }}
//                       >
//                         {property.location?.address?.formatted ||
//                           "Location not available"}
//                       </p>
//                       <div className=" text-[#797979] text-xs sm:text-sm">
//                         <div>
//                           Posted By {property.listedBy?.role || "Owner"}
//                         </div>
//                         <div className="flex justify-end mt-2">
//                           {new Date(property.createdAt).toLocaleDateString(
//                             "en-GB",
//                             {
//                               day: "2-digit",
//                               month: "short",
//                               year: "numeric",
//                             }
//                           )}
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             );
//           })}

//           {/* Render Coming Soon cards */}
//           {!loading &&
//             Array.from({ length: comingSoonCount }).map((_, index) =>
//               renderComingSoonCard(index)
//             )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RecommendedPropertySection;
